// import React, { useState, useEffect } from "react";
// import { io } from "socket.io-client";
// import { MessageCircle, Send, X, Bot, User } from "lucide-react";
// import { useParams } from "react-router-dom";

// export default function ChatBot() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     {
//       id: "1",
//       text: "Hello! How can I help you today?",
//       sender: "bot",
//       timestamp: new Date(),
//     },
//   ]);
// const { theme } = useParams();
// const {project_id}=useParams();
//   const [input, setInput] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const [socket, setSocket] = useState(null);
//   console.log(project_id);
//   const themes = {
//     default: {
//       headerBg: "bg-blue-600",
//       headerText: "text-white",
//       buttonBg: "bg-blue-600",
//       buttonHover: "hover:bg-blue-700",
//     },
//     dark: {
//       headerBg: "bg-gray-800",
//       headerText: "text-white",
//       buttonBg: "bg-gray-800",
//       buttonHover: "hover:bg-gray-900",
//     },
//     green: {
//       headerBg: "bg-green-600",
//       headerText: "text-white",
//       buttonBg: "bg-green-600",
//       buttonHover: "hover:bg-green-700",
//     },
//   };

//   const currentTheme = themes[theme || "default"] || themes["default"];

//   useEffect(() => {
//     const newSocket = io("https://demo.ailaa.ai", {
//       path: "/socket.io",
//       transports: ["websocket", "polling"],
//       withCredentials: true,
//     });
//     setSocket(newSocket);

//     newSocket.on("bot_reply", (data) => {
//       const botMessage = {
//         id: Date.now().toString(),
//         text: data.reply,
//         sender: "bot",
//         timestamp: new Date(),
//       };
//       setMessages((prev) => [...prev, botMessage]);
//       setIsLoading(false);
//     });

//     newSocket.on("error", (data) => {
//       const errorMessage = {
//         id: Date.now().toString(),
//         text: data.detail,
//         sender: "bot",
//         timestamp: new Date(),
//       };
//       setMessages((prev) => [...prev, errorMessage]);
//       setIsLoading(false);
//     });

//     return () => {
//       newSocket.disconnect();
//     };
//   }, []);

//   const handleSend = (e) => {
//     e.preventDefault();
//     if (!input.trim() || isLoading || !socket) return;

//     const userMessage = {
//       id: Date.now().toString(),
//       text: input,
//       sender: "user",
//       timestamp: new Date(),
//     };
//     setMessages((prev) => [...prev, userMessage]);
//     setIsLoading(true);

//     const chat_history = messages
//       .map((m) => `${m.sender === "user" ? "User" : "Bot"}: ${m.text}`)
//       .join("\n");

//     socket.emit("send_message", {
//       message: input,
//       chat_history,
//       project_id,
//     });

//     setInput("");
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       handleSend(e);
//     }
//   };

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         overflow: "hidden",
//       }}
//     >
//       {isOpen && (
//         <div className="bg-white rounded-lg shadow-xl w-full h-full flex flex-col">
//           <div
//             className={`${currentTheme.headerBg} ${currentTheme.headerText} p-4 rounded-t-lg flex justify-between items-center`}
//           >
//             <div className="flex items-center gap-2">
//               <Bot className="w-5 h-5" />
//               <h3 className="font-semibold">Ask Me</h3>
//             </div>
//             <button
//               onClick={() => setIsOpen(false)}
//               className="hover:text-gray-200"
//             >
//               <X size={20} />
//             </button>
//           </div>
//           <div
//             className="flex-1 p-4 space-y-4"
//             style={{ overflowY: "auto", overflowX: "hidden" }}
//           >
//             {messages.map((message) => (
//               <div
//                 key={message.id}
//                 className={`flex items-start gap-2.5 ${
//                   message.sender === "user" ? "flex-row-reverse" : ""
//                 }`}
//               >
//                 <div
//                   className={`w-8 h-8 rounded-full flex items-center justify-center ${
//                     message.sender === "user"
//                       ? currentTheme.buttonBg
//                       : "bg-gray-600"
//                   }`}
//                 >
//                   {message.sender === "user" ? (
//                     <User className="w-5 h-5 text-white" />
//                   ) : (
//                     <Bot className="w-5 h-5 text-white" />
//                   )}
//                 </div>
//                 <div
//                   className={`flex flex-col gap-1 max-w-[80%] ${
//                     message.sender === "user" ? "items-end" : "items-start"
//                   }`}
//                 >
//                   <div
//                     className={`rounded-lg p-3 ${
//                       message.sender === "user"
//                         ? `${currentTheme.buttonBg} text-white`
//                         : "bg-gray-100 text-gray-800 text-justify"
//                     }`}
//                   >
//                     {message.text}
//                   </div>
//                   <span className="text-xs text-gray-500">
//                     {message.timestamp.toLocaleTimeString([], {
//                       hour: "2-digit",
//                       minute: "2-digit",
//                     })}
//                   </span>
//                 </div>
//               </div>
//             ))}
//           </div>
//           <form onSubmit={handleSend} className="p-4 border-t border-gray-200">
//             <div className="flex gap-2">
//               <input
//                 type="text"
//                 value={input}
//                 onChange={(e) => setInput(e.target.value)}
//                 onKeyDown={handleKeyPress}
//                 placeholder="Type your message..."
//                 className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                 disabled={isLoading}
//               />
//               <button
//                 type="submit"
//                 className={`${currentTheme.buttonBg} ${currentTheme.buttonHover} text-white p-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed`}
//                 disabled={!input.trim() || isLoading}
//               >
//                 <Send size={20} />
//               </button>
//             </div>
//           </form>
//         </div>
//       )}
//       {!isOpen && (
//         <button
//           onClick={() => setIsOpen(true)}
//           className={`${currentTheme.buttonBg} ${currentTheme.buttonHover} text-white p-4 rounded-full shadow-lg transition-colors`}
//           style={{
//             position: "absolute",
//             bottom: "20px",
//             right: "20px",
//           }}
//         >
//           <MessageCircle size={24} />
//         </button>
//       )}
//     </div>
//   );
// }

import React, { useState, useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { Send, X, Bot, User, MessageCircle } from "lucide-react";
import { useParams } from "react-router-dom";

// Theme configurations
const themes = {
  default: {
    headerBg: "bg-blue-600",
    headerText: "text-white",
    buttonBg: "bg-blue-600",
    buttonHover: "hover:bg-blue-700",
    buttonShadow: "shadow-blue-400/40",
    userMessageBg: "bg-blue-600",
    botIconBg: "bg-gray-600",
  },
  dark: {
    headerBg: "bg-gray-800",
    headerText: "text-white",
    buttonBg: "bg-gray-800",
    buttonHover: "hover:bg-gray-900",
    buttonShadow: "shadow-gray-500/30",
    userMessageBg: "bg-gray-800",
    botIconBg: "bg-gray-600",
  },
  green: {
    headerBg: "bg-green-600",
    headerText: "text-white",
    buttonBg: "bg-green-600",
    buttonHover: "hover:bg-green-700",
    buttonShadow: "shadow-green-400/40",
    userMessageBg: "bg-green-600",
    botIconBg: "bg-gray-600",
  },
  purple: {
    headerBg: "bg-purple-600",
    headerText: "text-white",
    buttonBg: "bg-purple-600",
    buttonHover: "hover:bg-purple-700",
    buttonShadow: "shadow-purple-400/40",
    userMessageBg: "bg-purple-600",
    botIconBg: "bg-gray-600",
  },
  orange: {
    headerBg: "bg-orange-500",
    headerText: "text-white",
    buttonBg: "bg-orange-500",
    buttonHover: "hover:bg-orange-600",
    buttonShadow: "shadow-orange-400/40",
    userMessageBg: "bg-orange-500",
    botIconBg: "bg-gray-600",
  },
};

// Message Component
const Message = ({ message, currentTheme }) => {
  const isUser = message.sender === "user";

  return (
    <div
      className={`flex items-start gap-2.5 ${
        isUser ? "flex-row-reverse" : ""
      } mb-4`}
    >
      <div
        className={`w-8 h-8 rounded-full flex items-center justify-center ${
          isUser ? currentTheme.buttonBg : currentTheme.botIconBg
        }`}
      >
        {isUser ? (
          <User className="w-5 h-5 text-white" />
        ) : (
          <Bot className="w-5 h-5 text-white" />
        )}
      </div>
      <div
        className={`flex flex-col gap-1 max-w-[80%] ${
          isUser ? "items-end" : "items-start"
        }`}
      >
        <div
          className={`rounded-lg p-3 ${
            isUser
              ? `${currentTheme.userMessageBg} text-white`
              : "bg-gray-100 text-gray-800 text-justify"
          }`}
        >
          {message.text}
        </div>
        <span className="text-xs text-gray-500">
          {message.timestamp.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </span>
      </div>
    </div>
  );
};

// Chat Button Component
const ChatButton = ({ onClick, currentTheme }) => {
  return (
    <button
      onClick={onClick}
      className={`${currentTheme.buttonBg} ${currentTheme.buttonHover} text-white p-4 rounded-full shadow-lg transition-colors fixed bottom-5 right-5 z-50 
      ${currentTheme.buttonShadow} shadow-lg
      animate-chat-button hover:scale-110 transition-transform duration-300`}
      aria-label="Open chat"
    >
      <MessageCircle size={24} className="animate-pulse" />
    </button>
  );
};

// Main ChatBot Component
const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      id: "1",
      text: "Hello! How can I help you today?",
      sender: "bot",
      timestamp: new Date(),
    },
  ]);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [socket, setSocket] = useState(null);
  const messagesEndRef = useRef(null);
  const { theme } = useParams();
  const { project_id } = useParams();
  const inputRef = useRef(null);
  const currentTheme = themes[theme] || themes["default"];

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  useEffect(() => {
    if (!isLoading && isOpen) {
      inputRef.current?.focus();
    }
  }, [isLoading, isOpen]);

  useEffect(() => {
    const newSocket = io("https://demo.ailaa.ai", {
      path: "/socket.io",
      transports: ["websocket", "polling"],
      withCredentials: true,
    });
    setSocket(newSocket);

    newSocket.on("bot_reply", (data) => {
      const botMessage = {
        id: Date.now().toString(),
        text: data.reply,
        sender: "bot",
        timestamp: new Date(),
      };
      setMessages((prev) => [...prev, botMessage]);
      setIsLoading(false);
      inputRef.current?.focus();
    });

    newSocket.on("error", (data) => {
      const errorMessage = {
        id: Date.now().toString(),
        text:
          data.detail || "Sorry, there was an error processing your request.",
        sender: "bot",
        timestamp: new Date(),
      };
      setMessages((prev) => [...prev, errorMessage]);
      setIsLoading(false);
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);

  const handleSend = (e) => {
    e.preventDefault();
    if (!input.trim() || isLoading || !socket) return;

    const userMessage = {
      id: Date.now().toString(),
      text: input,
      sender: "user",
      timestamp: new Date(),
    };
    setMessages((prev) => [...prev, userMessage]);
    setIsLoading(true);

    const chat_history = messages
      .map((m) => `${m.sender === "user" ? "User" : "Bot"}: ${m.text}`)
      .join("\n");

    socket.emit("send_message", {
      message: input,
      chat_history,
      project_id,
    });

    setInput("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend(e);
    }
  };

  return (
    <>
      {isOpen ? (
        <div className="fixed inset-0 z-50 md:inset-auto md:right-5 md:bottom-5 md:w-96 md:h-[550px] flex flex-col bg-white rounded-lg shadow-2xl transition-all duration-300 ease-in-out">
          <div
            className={`${currentTheme.headerBg} ${currentTheme.headerText} p-4 rounded-t-lg flex justify-between items-center`}
          >
            <div className="flex items-center gap-2">
              <Bot className="w-5 h-5" />
              <h3 className="font-semibold">Ask Me</h3>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="hover:text-gray-200 transition-colors"
              aria-label="Close chat"
            >
              <X size={20} />
            </button>
          </div>

          <div className="flex-1 p-4 overflow-y-auto">
            {messages.map((message) => (
              <Message
                key={message.id}
                message={message}
                currentTheme={currentTheme}
              />
            ))}
            <div ref={messagesEndRef} />

            {isLoading && (
              <div className="flex items-start gap-2.5 mb-4">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center ${currentTheme.botIconBg}`}
                >
                  <Bot className="w-5 h-5 text-white" />
                </div>
                <div className="bg-gray-100 text-gray-800 rounded-lg p-3 flex space-x-1">
                  <div
                    className="w-2 h-2 bg-gray-500 rounded-full animate-bounce"
                    style={{ animationDelay: "0ms" }}
                  ></div>
                  <div
                    className="w-2 h-2 bg-gray-500 rounded-full animate-bounce"
                    style={{ animationDelay: "150ms" }}
                  ></div>
                  <div
                    className="w-2 h-2 bg-gray-500 rounded-full animate-bounce"
                    style={{ animationDelay: "300ms" }}
                  ></div>
                </div>
              </div>
            )}
          </div>

          <form onSubmit={handleSend} className="p-4 border-t border-gray-200">
            <div className="flex gap-2">
              <input
                ref={inputRef}
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyPress}
                placeholder="Type your message..."
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                disabled={isLoading}
              />
              <button
                type="submit"
                className={`${currentTheme.buttonBg} ${currentTheme.buttonHover} text-white p-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed`}
                disabled={!input.trim() || isLoading}
              >
                <Send size={20} />
              </button>
            </div>
          </form>
        </div>
      ) : (
        <ChatButton
          onClick={() => setIsOpen(true)}
          currentTheme={currentTheme}
        />
      )}
    </>
  );
};

export default ChatBot;
